export default "__VITE_ASSET__CQgY8u6i__"